export enum ScheduleType {
    /**
     * Поступление
     */
    INFLOW = 1,

    /**
     * Погашение основного долга
     */
    PRINCIPAL_REPAYMENT = 2,

    
    /**
     * Выплата вознаграждений
     */
    PAYMENT_INTEREST = 3,

    /**
     * Досрочное погашения
     */
    PAYMENT_REFUND = 4,

    /**
     * Сопутствующие платежи
     */
    PAYMENT_COPAYMENT = 5,

    /**
     * Пеня осн. долга
     */
    PAYMENT_PENALTY_PRINCIPAL = 6,

    /**
     * Пеня возн.
     */
    PAYMENT_PENALTY_INTEREST = 7,

    /**
     * Возврат неиспользованных средств
     */
    PAYMENT_UNUSED = 8
}
